import { queryOptions } from '@tanstack/react-query';
import { maxEndppointOIDCUsersQueryOptions } from '#api/endpoint-oidc-users.queries.ts';
import type { Item } from '#components/patterns/forms/select/select-async-searchable/SelectAsyncSearchable.tsx';
import { ANY_DEVICE_OWNER_OPTION, NO_DEVICE_OWNER_OPTION } from './option-constants.ts';

/**
 * Fetches a list of every endpoint oidc user in the account, 500 at a time, up to 5000 users.
 */
export function makeAllEndpointOIDCUsersQueryOptions(filterUsers: (option: Item) => boolean = () => true) {
  return queryOptions({
    ...maxEndppointOIDCUsersQueryOptions,
    select: (data) => {
      return {
        items: [
          NO_DEVICE_OWNER_OPTION,
          ANY_DEVICE_OWNER_OPTION,
          ...data.data.map((user) => ({ value: user.id, label: user.email })),
        ].filter((element) => filterUsers(element)),
      };
    },
  });
}
